<div class="fcp-tab">
    <ng-container *ngFor="let item of items">
        <div [ngClass]="getTabClasses(item)" data-e2e-hook="fcp-tab-selected" (click)="onClickTab(item.value)">
            <span
                [ngClass]="{
                    'fcp-tab-item': true,
                    'icon-align-start': item.icon && item.icon.position === 'start',
                    'icon-align-end': item.icon && item.icon.position === 'end',
                    'badge-align-end': item.badge && item.badge.position === 'end'
                }"
            >
                <ng-container *ngIf="item.icon">
                    <fcp-icon-svg
                        *ngIf="isSvgIcon(item.icon.name)"
                        [icon]="item.icon.name"
                        [color]="getIconColor(item)"
                    ></fcp-icon-svg>
                    <fcp-icon
                        *ngIf="!isSvgIcon(item.icon.name)"
                        [icon]="item.icon.name"
                        [style]="item.icon.style"
                        [border]="item.icon.border"
                        [isCustom]="item.icon.isCustom"
                    ></fcp-icon>
                </ng-container>
                <ng-container *ngIf="item.text">{{ item.text }}</ng-container>
            </span>
            <fcp-badge
                *ngIf="item.badge"
                [text]="item.badge.value"
                [color]="item.badge.color"
                [size]="item.badge.size"
            ></fcp-badge>
        </div>
    </ng-container>
</div>
